module.exports = __webpack_public_path__ + "fonts/PilatExtended-Book.woff2";